
<div class="container-fluid">
  <div class="card card-custom-h">
    <div class="card-body">
      <form [formGroup]="EditForm" *ngIf="IsAEditFormLoaded" (ngSubmit)="editHeaderTemplate()">
        <div class=" row">
          <div class="col-md-12">
            <BBSF-MultiLingualTextBox [options]="MultiLingualName" [group]="EditForm"></BBSF-MultiLingualTextBox>

          </div>
        </div>
      
        <div class=" row">
          <div class="col-md-12">
            <BBSF-MultiLingualHtmlEditor  [options]="MultiLingualHeader" [group]="EditForm"></BBSF-MultiLingualHtmlEditor >
          </div>
        </div>

        <div class=" row">
          <div class="col-md-12 table-dark-skin">
            <BBSF-MultiLingualHtmlEditor  [options]="MultiLingualFooter" [group]="EditForm"></BBSF-MultiLingualHtmlEditor >
            </div>
        </div>
       
        <div class=" row">
          <div class="col-md-12 ">
            <BBSF-MultiLingualHtmlEditor  [options]="MultiLingualHtmlHeadSection" [group]="EditForm"></BBSF-MultiLingualHtmlEditor >
          </div>
        </div>
        <div class=" row">
          <div class="col-md-12">
            <BBSF-MultiLingualTextBox [options]="MultiLingualHtmlHeadTagAttributes" [group]="EditForm"></BBSF-MultiLingualTextBox>

          </div>
        </div>
      </form>
    </div>
    <div class="card-footer border-0 d-flex justify-content-end">
      <button #CloseAddModal id="CloseAddModal" type="button" class="btn btn-light-primary btn-sm me-3" (click)="close()">{{utilityService.getResourceValue("CancelLabel")}}</button>
      <button type="submit" class="btn btn-primary btn-sm ">{{utilityService.getResourceValue("SaveLabel")}}</button>
    </div>
  </div>

</div>


